export const FAKETOKEN_ENDPOINT_MEMBRE =
    'https://simulateur-backend-parcours-habitation.apps.cfzcea.dev.desjardins.com/accesd/tokenv2?role=membre&isApp=false&institution=815&pdo=';
export const FAKETOKEN_ENDPOINT_CONSEILLER =
    'https://simulateur-backend-parcours-habitation.apps.cfzcea.dev.desjardins.com/accesd/tokenv2?role=ROLE_UTILISATEUR_CONSEILLER&isApp=false&institution=815&pdo=';

export async function useFakeTokenApi(
    pdo: string,
    role?: string
): Promise<any> {
    const urlToCall =
        role !== null && role.toUpperCase().includes('CONSEILLER')
            ? FAKETOKEN_ENDPOINT_CONSEILLER
            : FAKETOKEN_ENDPOINT_MEMBRE;
    // Fetch
    const response = await fetch(urlToCall + pdo, {
        method: 'GET',
        cache: 'no-cache',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
    return response.text();
}
